'use strict';
const mmWidgets = require('./mm-widgets'),
	_ = require('underscore');
mmWidgets.fn.dispatchedEventToggleWidget = function (eventDispatcher, events, eventValueDataKey, valueAttrName, toggleClassDataAttrName) {
	return mmWidgets.each(this, function () {
		const widget = this,
			listenTo = events.join(' '),
			actionClass = widget.attr(toggleClassDataAttrName) || 'hidden',
			getEventValueAsArray = function (eventArg) {
				const eventValueKey = eventValueDataKey && widget.attr(eventValueDataKey);
				let val,
					keys = eventValueKey && eventValueKey.split('.'),
					obj = eventArg;
				if (!keys) {
					return [];
				}

				while (obj && keys.length > 1) {
					obj = obj[keys[0]];
					keys = keys.slice(1);
				}

				if (obj && keys.length && obj[keys[0]]) {
					val = obj[keys[0]];
					if (!val) {
						return [];
					} else if (Array.isArray(val)) {
						return val;
					} else {
						return [val];
					}
				}

			},
			toggleForEvent = function (eventArg) {
				const values = getEventValueAsArray(eventArg),
					attrValue = widget.attr(valueAttrName),
					invert = attrValue[0] === '!',
					expectedValue = invert ? attrValue.slice(1) : attrValue,
					expectedValues = (expectedValue && expectedValue.split(' ')) || [];
				let remove = false;
				if (values && values.length && expectedValue === '*') {
					remove = true;
				} else if (_.intersection(values, expectedValues).length) {
					remove = true;
				} else if ((!values || !values.length) && _.contains(expectedValues, 'none')) {
					remove = true;
				}
				if (invert) {
					remove = !remove;
				}
				if (remove) {
					widget.removeClass(actionClass);
				} else {
					widget.addClass(actionClass);
				}
			};
		eventDispatcher.addEventListener(listenTo, toggleForEvent);
	});
};

